module.exports = __webpack_public_path__ + "static/media/carmen.32638d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carmen.png
// module id = 311
// module chunks = 0